import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CoreI18nModule } from '@nx-ratenow/core/i18n';
import { AuthGuard } from '@nx-ratenow/core/guards';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { getUserLoggedResolver } from '@nx-ratenow/shared/resolvers';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@nx-ratenow/core/feature-auth').then(
        (m) => m.CoreFeatureAuthModule
      )
  },
  {
    path: 'errors',
    loadChildren: () =>
      import('@nx-ratenow/core/errors/feature-error-pages').then(
        (m) => m.CoreErrorsFeatureErrorPagesModule
      )
  },
  {
    path: '',
    component: MainLayoutComponent,
    resolve: { userLoggedInfo: getUserLoggedResolver },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'account-settings',
        loadChildren: () =>
          import('@nx-ratenow/account-settings/main').then(
            (module) => module.AccountSettingsMainModule
          )
      },
      // {
      //   path: 'dashboard',
      //   loadChildren: () =>
      //     import('@nx-ratenow/config-dashboard/main').then(
      //       (module) => module.ConfigDashboardModule
      //     )
      // },
      {
        path: 'documentation',
        loadChildren: () =>
          import('@nx-ratenow/documentation/main').then(
            (module) => module.DocumentationMainModule
          )
      },
      {
        path: 'users',
        loadChildren: () =>
          import('@nx-ratenow/config-users/main').then(
            (module) => module.ConfigUsersModule
          )
      },
      {
        path: 'user-groups',
        loadChildren: () =>
          import('@nx-ratenow/config-user-groups').then(
            (module) => module.ConfigUserGroupsModule
          )
      },
      {
        path: 'devices',
        loadChildren: () =>
          import('@nx-ratenow/config-devices/main').then(
            (module) => module.ConfigDevicesModule
          )
      },
      {
        path: 'alerts',
        loadChildren: () =>
          import('@nx-ratenow/config-alerts').then(
            (module) => module.ConfigAlertsModule
          )
      },
      {
        path: 'organization',
        loadChildren: () =>
          import('@nx-ratenow/config-organization/main').then(
            (module) => module.ConfigOrganizationModule
          )
      },
      {
        path: '',
        redirectTo: 'account-settings',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/errors/404'
  }
];

@NgModule({
  imports: [
    CoreI18nModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      paramsInheritanceStrategy: 'always',
      bindToComponentInputs: true
    })
  ],
  exports: [TranslateModule, RouterModule]
})
export class AppAdminUserRoutingModule {}
